import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommentsTabComponent } from '../../../../../@shared/components/innform-question-sidepanel/tabs/comments/comments-tab.component';
import { COMMENTS_TYPE } from '../../../../../@core/models/enums';
import { EditContractDataService } from '../../../../services/edit-contract-data.service';

@Component({
    selector: 'app-comments-tab-wrapper',
    standalone: true,
    imports: [CommonModule, CommentsTabComponent],
    template: `
        <app-comments-tab class="block h-full w-full" [itemId]="contractId()" [contractId]="contractId()"
            [commentsType]="COMMENTS_TYPE.CONTRACT"></app-comments-tab>
    `,
    styles: [`
        :host {
            display: block;
            height: 100%;
            width: 100%;
        }
    `]
})
export class CommentsTabWrapperComponent {
    COMMENTS_TYPE = COMMENTS_TYPE;

    constructor(public dataService: EditContractDataService) { }

    // Use getter methods to access computed signals from the service - these will auto-update!
    get contractId() { return this.dataService.contractId; }
}

